import {appAPI} from "../../../api";
import {transliterate} from "../../../utils/services";
import axios from "axios";

export const filesPath = `/file`;

export const filesAPI = {
    upload: async (file: File) => {
        const ext = file.name.split(".").pop();
        const baseNameRaw = file.name.replace(/\.[^/.]+$/, "");
        const baseNameTranslit = transliterate(baseNameRaw).replace(/[^a-zA-Z0-9]/g, "_");
        const uniqueName = `${baseNameTranslit}_${Date.now()}.${ext}`;
        const renamedFile = new File([file], uniqueName, {type: file.type});
        const formData = new FormData();
        formData.append("file", renamedFile);
        const response = await appAPI.post(filesPath, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        });
        return response.data.name;
    },
    delete: async (filename: string) => {
        try {
            const response = await appAPI.delete(`${filesPath}/${filename}`);
            return response.data;
        } catch (e) {
        }
    },
};

// Прямая загрузка файла в S3 по presigned URL.
// ВАЖНО: content_type здесь обязан совпадать с тем, что был передан
// в getUploadUrl при подписи — иначе S3 вернёт 403 SignatureDoesNotMatch.
export const uploadFileToS3 = async (
    uploadUrl: string,
    file: File,
    contentType: string,
    onProgress?: (percent: number) => void,
): Promise<void> => {
    await axios.put(uploadUrl, file, {
        headers: {
            "Content-Type": contentType,
        },
        // отключаем твои глобальные интерсепторы/креды — это чужой домен
        transformRequest: [(data) => data],
        onUploadProgress: (e) => {
            if (onProgress && e.total) {
                onProgress(Math.round((e.loaded * 100) / e.total));
            }
        },
    });
};
